module.exports = __webpack_public_path__ + "img/app.41bfd89c.jpg";